import { gql, type TypedDocumentNode } from "@apollo/client";
import { Section } from "@/types";

export type SectionFragment = {
  section: Section & { permissions: { manageChangeformSettings: boolean; manageChangeRequests: boolean } };
};

export const SECTION_PERMISSIONS_FRAGMENT = gql`
  fragment SectionPermissionsFields on BackofficeSectionPermissions {
    manageChangeformSettings
    manageChangeRequests
    manageEvents
    manageNotificationEmails
  }
`;

export const SECTION_FRAGMENT = gql`
  fragment SectionFragment on BackofficeSection {
    id
    name
    legacyId
    permissions {
      manageChangeformSettings
      manageChangeRequests
    }
  }
`;

export const SECTION_DETAILS_HEADER_QUERY = gql`
  query section($sectionId: ID!) {
    section(id: $sectionId) {
      id
      name
      legacyId
      permissions {
        manageChangeformSettings
        manageChangeRequests
      }
    }
  }
`;

export type SectionPermissions = {
  manageChangeformSettings: boolean;
  manageChangeRequests: boolean;
  manageEvents: boolean;
  manageNotificationEmails?: boolean;
};

export type SectionNavQueryResponse = {
  section: {
    id: string;
    sectionOffice: { id: string } | null;
    permissions: SectionPermissions;
  };
};

export type SectionNavQueryVariables = {
  sectionId: string;
  includeNotificationPermissions: boolean;
};

// Keep manageNotificationEmails off this document until the flag is on so audit log,
// billing, operations, and mobile nav stay valid against today's production schema.
export const SECTION_NAV_QUERY: TypedDocumentNode<SectionNavQueryResponse, SectionNavQueryVariables> = gql`
  query sectionNav($sectionId: ID!, $includeNotificationPermissions: Boolean!) {
    section(id: $sectionId) {
      id
      sectionOffice {
        id
      }
      permissions {
        manageChangeformSettings
        manageChangeRequests
        manageEvents
        manageNotificationEmails @include(if: $includeNotificationPermissions)
      }
    }
  }
`;
